<app-maintenance-gate>
    <div appCatchEvents>
        <app-header>
            <div class="root">
                @if (isLoading$ | async) {
                    <app-initial-loader></app-initial-loader>
                }
                @if ((isLoading$ | async) === false) {
                    <router-outlet></router-outlet>
                }
            </div>
        </app-header>
    </div>
</app-maintenance-gate>
